
import Vue from 'vue'// Vuex版本为3.6.2

// Vuex3.x版本为vue2.x适配
// Vuex4.x版本为vue3.x适配
// 查Vuex文档时记得把文档版本调成3.x
import Vuex from 'vuex'
Vue.use(Vuex)

// Vuex持久化存储
// 把Vuex的state转为JSON字符串存进某个storage里
// 例如localStorage、sessionStorage
import VuexPersistence from 'vuex-persist'
const vuexLocal = new VuexPersistence({
    storage: localStorage
})
const plug_AfterVuexPersist = store => {
	// 当 store 初始化后调用
	// #init
	// 现在没时间自己写一个vuex缓存插件，只能自己手动初始化
	const temp_State = spawn_State()
	store.state.footerData = temp_State.footerData
	store.state.portait_Default = temp_State.portait_Default
	console.log(store.state.portait_Default)
}

// 封装的axios
import server from '../assets/server.js'

// （挂载在Vue实例上的）路由实例
import $router from '../router/index.js'

// 判断设备类型
import judgeDeviceType from '../assets/judgeDeviceType.js'
// 设备类型
const deviceType = judgeDeviceType()
// WARNING:
// 因为VuexPersistence在store初始化之后采用storage的数据恢复到store中，
// 所以deviceType会继承storage里的，导致在store中的初始化数据被覆盖，
// 如果需要正确的、动态的deviceType（一般在浏览器调试才需要动态的deviceType）有两种办法，
// 一是退出登录或者登录，这个不用改代码；
// 二是在某个vue组件的初始化周期里设置deviceType，这个找个喜欢的地方加一下就好了，记得作标记免得后人找不到地方。
// 目前采用第二种办法，在topbar.vue里调用 store.commit('setDeviceType')。
console.log('deviceType =>', deviceType)


function spawn_State() {
	return {
		deviceType: deviceType || 'phone',
		// systemType:0,
		// boundH:0,
		// invite_code:"",
		// share_user_id:"",
		// isChannel:0,
		// isSub:0,

		// 全局通用logo Url
		logo: 'https://sxh-1253575465.file.myqcloud.com/shops/image/logo.jpg',
		portait_Default: 'https://sxh-1253575465.file.myqcloud.com/Integer_shop/img/1691999878ytQj.png',

		// #支付api
		payUrl: {
			// 微信支付
			wxUrl: "",
			// 支付宝支付
			aliPayUrl:"",
		},

		// #分类
		terms: [],

		// #购物车商品列表
		carData: [],

		// #页头
		pageHead: {
			isShow: false,
			title: '返回',
			content: '',
			callback: () => {
				console.log($router)
				$router.back()
			}
		},


		/** @zh footer 和 article 共用此项 */
		footerData: [
			{
				colData: [
					{ name: '关于我们', url: '', id: '1' },
					{ name: '商户简介', url: '', id: '2' },
					{ name: '正品承诺', url: '', id: '3' },
					{ name: '联系我们', url: '', id: '4' },
				]
			},
			{
				colData: [
					{ name: '消费者指南', url: '', id: '5' },
					{ name: '购物流程', url: '', id: '6' },
					{ name: '通关税费', url: '', id: '7' },
					{ name: '常见问题', url: '', id: '8' },
				]
			},
			{
				colData: [
					{ name: '物流配送', url: '', id: '9' },
					{ name: '运送方式', url: '', id: '10' },
					{ name: '运费标准', url: '', id: '11' },
					{ name: '物流跟踪', url: '', id: '12' },
				]
			},
			{
				colData: [
					{ name: '售后政策', url: '', id: '13' },
					{ name: '退货政策', url: '', id: '14' },
					{ name: '退款说明', url: '', id: '15' },
				]
			},
			{
				colData: [
					{ name: '网站政策', url: '', id: '16' },
					{ name: '服务条款', url: '', id: '17' },
					{ name: '隐私权保护政策', url: '', id: '18' },
					{ name: '消费者告知书', url: '', id: '19' },
				]
			},
		],

		// #微信用户信息
		wxUserInfo: {
			code: '',
			state: ''
		},

		// #登录用户信息（登录态信息）
		userInfo: {
			// token也用来判断登录态
			token:"",
			carNum: 0,
			service_openId: null,
			user_code: ""
		},
	}
}

const store = new Vuex.Store({
	plugins: [
		vuexLocal.plugin,
		plug_AfterVuexPersist
	],
	state: spawn_State(),
	mutations: {
		// #全局方法
		// 登出操作
		logout(state) {
			Object.assign(state, {
				// deviceType: deviceType || 'phone',
				// systemType:0,
				// boundH:0,
				// invite_code:"",
				// share_user_id:"",
				// isChannel:0,
				// isSub:0,

				// // #分类
				// terms: [],

				// #购物车商品列表
				carData: [],

				// // #页头
				// pageHead: {
				// 	isShow: false,
				// 	title: '返回',
				// 	content: '',
				// 	callback: () => {
				// 		// console.log($router)
				// 		$router.back()
				// 	}
				// },

				// #微信用户信息
				wxUserInfo: {
					code: '',
					state: ''
				},

				// #登录用户信息（登录态信息）
				userInfo: {
					// token也用来判断登录态
					token:"",
					carNum: 0,
					service_openId: null,
					user_code: ""
				},
			})
		},

		// #设置器
		setDeviceType(state, payload) {
			state.deviceType = payload || judgeDeviceType()
		},
		setTerms(state, payload) {
			state.terms = payload
		},
		setPageHead(state, payload) {
			// #默认值
			if(payload.isShow === undefined) {
				payload.isShow = true
			}
			if(state.pageHead.title === undefined) {
				state.pageHead.title = '返回'
			}
			if(! state.pageHead.callback) {
				// console.log('setPageHead: default callback')
				state.pageHead.callback = () => {
					$router.back()
				}
			}

			// 替换对象引用值
			if(payload.$replaceReference) {
				state.pageHead = payload
			}
			// 替换属性值
			else {
				// Object.assign(state.pageHead, payload)
				state.pageHead = {
					...state.pageHead,
					...payload
				}
			}

			// console.log('pageHead =>', state.pageHead)
		},
		setFooterData(state, payload) {
			state.footerData = payload
		},
		wxUserInfo(state, payload) {
			// 替换对象引用值
			if(payload.$replaceReference) {
				state.wxUserInfo = payload
			}
			// 替换属性值
			else {
				// Object.assign(state.wxUserInfo, payload)
				state.wxUserInfo = {
					...state.wxUserInfo,
					...payload
				}
			}
		},
		setUserInfo(state, payload) {
			// 替换对象引用值
			if(payload.$replaceReference) {
				state.userInfo = payload
			}
			// 替换属性值
			else {
				// Object.assign(state.userInfo, payload)
				state.userInfo = {
					...state.userInfo,
					...payload
				}
			}
			console.log('userInfo =>', state.userInfo)
		},
		setCarData(state, payload) {
			state.carData = payload
			state.userInfo.carNum = payload.length
		},
	},
	actions: {
		// 获取商品分类
		getTerms(context) {
			// /index.php/AppInterface/Brand/lower_term
			return this.$server.post('/index.php/AppInterface/Brand/term', {

			})
			.then(res => {
				// console.log('Terms =>', res)
				switch (res.result) {
					case 1:
						// this.terms = res.data.term || []
						context.commit('setTerms', res.data.term || [])
						break;
					default:
						this.$message.warning(res.msg)
						break;
				}

				return res
			})
			.catch(err => {
				console.error('getTerms: error =>', err)
				this.$message.error(this.$t('common.require-error'))
			})
		},
	},
	getters: {
		// #获取器
		deviceType(state) {
			return state.deviceType
		},
		terms(state) {
			return state.terms
		},
		carData(state) {
			return state.carData
		},
		pageHead(state) {
			return state.pageHead
		},
		footerData(state) {
			return state.footerData
		},
		wxUserInfo(state) {
			return state.wxUserInfo
		},
		userInfo(state) {
			return state.userInfo
		},
		payUrl(state) {
			return state.payUrl
		},
		logo(state) {
			return state.logo
		},
		portait_Default(state) {
			return state.portait_Default
		},
	},
})

// 为vuex实例挂载axios
store.__proto__.$server = server

export default store



// WEBPACK FOOTER //
// ./src/store/store.js